var cartTriggers = document.querySelectorAll('.gokwik-cart-trigger');

cartTriggers.forEach(function (el) {
  el.addEventListener('click', function (e) {
    e.preventDefault();

    // Try both methods depending on GoKwik setup
    if (window.GoKwik && window.GoKwik.cart && typeof window.GoKwik.cart.open === 'function') {
      window.GoKwik.cart.open();
    } else {
      // Fallback: click header cart icon if available
      var headerCartIcon = document.querySelector('[data-cart-sidebar]');
      if (headerCartIcon) headerCartIcon.click();
    }
  });
});